import React, { useState, useRef } from "react";
import NewFolderPopover from "./NewFolderPopover";

interface SidebarHeaderProps {
  isCollapsed: boolean;
  onToggle: () => void;
  onNewChat: () => void;
  onCreateFolder: (name: string) => void;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  isCollapsed,
  onToggle,
  onNewChat,
  onCreateFolder,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const folderBtnRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <div className="sidebar-logo">
        <img src="/logo.svg" alt="Company logo" />
      </div>

      <div className="sidebar-header">

        {/* ── Collapsed ── */}
        {isCollapsed && (
          <>
            <button className="sidebar-expand-btn" onClick={onToggle} title="Expand sidebar">
              <i className="fas fa-chevron-right" />
            </button>
            <button className="new-chat-btn" onClick={onNewChat} title="New chat">
              <i className="fas fa-plus" />
            </button>
            <button
              ref={folderBtnRef}
              className="new-chat-btn"
              onClick={() => setIsPopoverOpen((o) => !o)}
              title="New folder"
            >
              <i className="fas fa-folder-plus" />
            </button>
          </>
        )}

        {/* ── Expanded ── */}
        {!isCollapsed && (        <div className="sidebar-header-row">
            <button className="new-chat-btn" onClick={onNewChat} title="New chat">
              <i className="fas fa-plus" />
              <span>New chat</span>
            </button>
            <button className="collapse-btn" onClick={onToggle} title="Collapse sidebar">
              <i className="fas fa-chevron-left" />
            </button>
          </div>
        )}

      </div>

      <NewFolderPopover
        isOpen={isPopoverOpen}
        anchorRef={folderBtnRef}
        onClose={() => setIsPopoverOpen(false)}
        onConfirm={onCreateFolder}
      />
    </>
  );
};

export default SidebarHeader;